
  function setPopupBelowHeader() {
    const header = document.querySelector('header');
    const popup = document.querySelector('.cstm-tog-selector-container-size-chart-popup');
    const content = document.querySelector('.cstm-tog-selector-container-size-chart-content');
    const closeBtn = document.querySelector('.cstm-tog-selector-container-close');

    if (!header || !popup || !content || !closeBtn) return;

    let finalOffset;

    if (window.innerWidth > 1025) {
      // 🔥 Desktop: controlled spacing (avoid over-push)
      const extraOffset = window.innerHeight * 0.02;

      // 140 header (fixed) + ~60 for close button zone + small breathing
      finalOffset = 140 + 90 + extraOffset;
    } else {
      // 📱 Mobile/tablet: keep your original working logic
      const headerBottom = Math.ceil(header.getBoundingClientRect().bottom);
      const closeOffset = Math.abs(closeBtn.offsetTop) + closeBtn.offsetHeight;
      const extraOffset = window.innerHeight * 0.02;

      finalOffset = headerBottom + closeOffset + extraOffset;
    }

    popup.style.alignItems = 'flex-start';
    popup.style.paddingTop = finalOffset + 'px';
  }

  // Initial run
  setPopupBelowHeader();

  // Recalculate on scroll/resize
  window.addEventListener('scroll', setPopupBelowHeader, { passive: true });
  window.addEventListener('resize', setPopupBelowHeader);
